// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tracking {
  background-color: var(--tracking-bg-color);
  border-bottom: 1px solid var(--tracking-border);
  display: flex;
}

@media (max-width: 48rem) {

#tracking {
    flex-direction: column;
    flex: 0 0 8rem;
}
  }

#tracking-text {
  padding: 0.5rem;
  font-size: 0.75rem;
}

#tracking-text a {
    color: var(--white);
  }

#tracking-buttons {
  display: flex;
  padding: 0.5rem;
}

#tracking-buttons button {
    font-size: 1rem;
    border-radius: 0.5rem;
    height: 2rem;
    line-height: 2rem;
    box-sizing: border-box;
    width: 7rem;
  }

@media (max-width: 48rem) {

#tracking-buttons button {
      width: 50%;
  }
    }

#accept-button {
  background-color: var(--tracking-btn-color);
  border: 1px solid var(--tracking-btn-border-color);
  color: var(--black);
  margin-right: 0.5rem;
}

#decline-button {
  background-color: var(--btn-bg-color);
  border: 1px solid var(--border-dark-color);
  color: var(--white);
}
`, "",{"version":3,"sources":["webpack://./core/components/Tracking.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,aAAa;AAMf;;AAJE;;AALF;IAMI,sBAAsB;IACtB,cAAc;AAElB;EADE;;AAGF;EACE,eAAe;EACf,kBAAkB;AAKpB;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,aAAa;EACb,eAAe;AAcjB;;AAZE;IACE,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;EAKb;;AAHE;;AARF;MASI,UAAU;EAEd;IADE;;AAIJ;EACE,2CAA2C;EAC3C,kDAAkD;EAClD,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;AACrB","sourcesContent":["#tracking {\r\n  background-color: var(--tracking-bg-color);\r\n  border-bottom: 1px solid var(--tracking-border);\r\n  display: flex;\r\n\r\n  @media (max-width: 48rem) {\r\n    flex-direction: column;\r\n    flex: 0 0 8rem;\r\n  }\r\n}\r\n\r\n#tracking-text {\r\n  padding: 0.5rem;\r\n  font-size: 0.75rem;\r\n\r\n  & a {\r\n    color: var(--white);\r\n  }\r\n}\r\n\r\n#tracking-buttons {\r\n  display: flex;\r\n  padding: 0.5rem;\r\n\r\n  & button {\r\n    font-size: 1rem;\r\n    border-radius: 0.5rem;\r\n    height: 2rem;\r\n    line-height: 2rem;\r\n    box-sizing: border-box;\r\n    width: 7rem;\r\n\r\n    @media (max-width: 48rem) {\r\n      width: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n#accept-button {\r\n  background-color: var(--tracking-btn-color);\r\n  border: 1px solid var(--tracking-btn-border-color);\r\n  color: var(--black);\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n#decline-button {\r\n  background-color: var(--btn-bg-color);\r\n  border: 1px solid var(--border-dark-color);\r\n  color: var(--white);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
